// extracted by mini-css-extract-plugin
export default {"NotFoundHeader":"NotFoundHeader_NotFoundHeader__4rJIC"};